/**
 * SN-8350 — the Team Finder's Gender Category filter: the DIVISION's gender
 * category (gender_type — Male/Men's, Female/Women's, Coed, N/A), the same list
 * Division Settings uses. "All Genders" is an explicit first choice that sends
 * nothing; in the form it is '' like every other unset filter.
 */
export const ALL_GENDER_CATEGORIES = 'all'

export interface GenderCategory {
  id: string | number
  name: string
}

export interface GenderCategoryOption {
  label: string
  value: string
}

/** "All Genders" first, then the categories. */
export const genderCategoryOptions = (
  categories: readonly GenderCategory[] | null | undefined,
  allLabel: string
): GenderCategoryOption[] => [
  { label: allLabel, value: ALL_GENDER_CATEGORIES },
  ...(categories ?? []).map((category) => ({
    label: category.name,
    value: String(category.id),
  })),
]

/** The select's value for the form's `genderId` — unset reads as All Genders. */
export const genderCategorySelectValue = (genderId: string): string =>
  genderId || ALL_GENDER_CATEGORIES

/** The form's `genderId` for a selection — All Genders (or a clear) is unset. */
export const genderIdFromSelection = (value?: string | null): string =>
  !value || value === ALL_GENDER_CATEGORIES ? '' : value
